<template>
  <div class="aside">
    <div class="menus-box">
      <div class="menus">
        <template v-for="item in menus">
          <!-- 一级菜单 -->
          <div :key="item.path" v-if="!item.children || item.children.length == 0" class="menus-item level-1">
            <router-link :to="item.path" class="menus-item-link v-row v-center" :class="{ active: activeIndex == item.path }">
              <i class="menus-item-icon iconfont" :class="[getIcon(item)]"></i>
              <span class="menus-item-txt">{{ item.meta && item.meta.title ? item.meta.title : '' }}</span>
            </router-link>
          </div>

          <!-- 二级菜单 -->
          <div :key="item.path" v-else class="menus-item level-2">
            <div @click="openSubMenu(item)" class="menus-item-title v-row v-center" :class="{ active: hasActiveSubmenu(item) }">
              <i class="menus-item-icon iconfont" :class="[getIcon(item)]"></i>
              <span class="menus-item-txt">{{ item.meta.title }}</span>
              <i class="menus-item-arrow iconfont icon-arrow-bottom" :class="{ active: item.open }"></i>
            </div>
            <div
              class="menus-item-submenu"
              :style="{
                height: !item.open ? 0 : getAvalibleRouter(item).length * 60 + 'px',
              }"
            >
              <router-link :to="child.path" v-for="child in getAvalibleRouter(item)" :key="child.path" class="menus-item-link v-row v-center" :class="{ active: activeIndex == child.path }">
                <i class="menus-item-icon iconfont" :class="[getIcon(child)]"></i>
                <div class="menus-item-txt">{{ child.meta.title }}</div>
              </router-link>
            </div>
          </div>
        </template>

        <template v-if="config.WEB == 1">
          <div class="menus-item level-1">
            <router-link to="/wx" class="menus-item-link v-row v-center" :class="{ active: activeIndex == '/wx/wx' }">
              <i class="menus-item-icon iconfont icon-wx"></i>
              <span class="menus-item-txt">小程序管理</span>
            </router-link>
          </div>
          <div class="menus-item level-1">
            <router-link to="/region" class="menus-item-link v-row v-center" :class="{ active: activeIndex == '/region/region' }">
              <i class="menus-item-icon iconfont icon-city"></i>
              <span class="menus-item-txt">地域数据管理</span>
            </router-link>
          </div>
          <div class="menus-item level-1">
            <router-link to="/polyline-type" class="menus-item-link v-row v-center" :class="{ active: activeIndex == '/polyline-type/polyline-type' }">
              <i class="menus-item-icon iconfont icon-polyline-type"></i>
              <span class="menus-item-txt">数据类型管理</span>
            </router-link>
          </div>
          <div class="menus-item level-1">
            <router-link to="/repeat-task" class="menus-item-link v-row v-center" :class="{ active: activeIndex == '/repeat-task/repeat-task' }">
              <i class="menus-item-icon iconfont icon-task"></i>
              <span class="menus-item-txt">复拍上传</span>
            </router-link>
          </div>
          <!--          <div class="menus-item level-1">-->
          <!--            <router-link-->
          <!--              to="/permission-node"-->
          <!--              class="menus-item-link v-row v-center"-->
          <!--              :class="{-->
          <!--                active: activeIndex == '/permission-node/permission-node',-->
          <!--              }"-->
          <!--            >-->
          <!--              <i class="menus-item-icon iconfont icon-node"></i>-->
          <!--              <span class="menus-item-txt">节点管理</span>-->
          <!--            </router-link>-->
          <!--          </div>-->
          <!--          <div class="menus-item level-1">-->
          <!--            <router-link-->
          <!--              to="/permission-role"-->
          <!--              class="menus-item-link v-row v-center"-->
          <!--              :class="{-->
          <!--                active: activeIndex == '/permission-role/permission-role',-->
          <!--              }"-->
          <!--            >-->
          <!--              <i class="menus-item-icon iconfont icon-users"></i>-->
          <!--              <span class="menus-item-txt">角色管理</span>-->
          <!--            </router-link>-->
          <!--          </div>-->
          <div class="menus-item level-1">
            <router-link
              to="/permission-account-admin"
              class="menus-item-link v-row v-center"
              :class="{
                active: activeIndex == '/permission-account-admin/permission-account-admin',
              }"
            >
              <i class="menus-item-icon iconfont icon-account"></i>
              <span class="menus-item-txt">平台账号管理</span>
            </router-link>
          </div>
          <div class="menus-item level-1">
            <router-link
              to="/permission-account-saas"
              class="menus-item-link v-row v-center"
              :class="{
                active: activeIndex == '/permission-account-saas/permission-account-saas',
              }"
            >
              <i class="menus-item-icon iconfont icon-account"></i>
              <span class="menus-item-txt">SaaS账号管理</span>
            </router-link>
          </div>
          <div class="menus-item level-1">
            <router-link to="/menus" class="menus-item-link v-row v-center" :class="{ active: activeIndex == '/menus/menus' }">
              <i class="menus-item-icon iconfont icon-menu"></i>
              <span class="menus-item-txt">SaaS菜单管理</span>
            </router-link>
          </div>
        </template>

        <template v-else>
          <div class="menus-item level-1">
            <router-link to="/repeat-task" class="menus-item-link v-row v-center" :class="{ active: activeIndex == '/repeat-task/repeat-task' }">
              <i class="menus-item-icon iconfont icon-task"></i>
              <span class="menus-item-txt">复拍上传</span>
            </router-link>
          </div>
        </template>

        <template v-if="config.WEB == 2 || config.WEB == 5 || config.WEB == 10 || config.WEB == 11">
          <div class="menus-item level-1">
            <router-link to="/polyline-chart" class="menus-item-link v-row v-center" :class="{ active: activeIndex == '/polyline-chart/polyline-chart' }">
              <i class="menus-item-icon iconfont icon-polyline-chart"></i>
              <span class="menus-item-txt">任务统计</span>
            </router-link>
          </div>
        </template>

        <template v-if="config.WEB == 3">
          <div class="menus-item level-1">
            <router-link to="/polyline-chart-tz" class="menus-item-link v-row v-center" :class="{ active: activeIndex == '/polyline-chart-tz/polyline-chart-tz' }">
              <i class="menus-item-icon iconfont icon-polyline-chart"></i>
              <span class="menus-item-txt">数据统计</span>
            </router-link>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      config: this.config,
      info: {},
      isShowModifyLogo: false,
    };
  },
  computed: {
    activeIndex() {
      return this.$route.fullPath;
    },

    menus() {
      return this.$store.state.router.routerMenus;
    },
  },

  methods: {
    //初始化菜单展开
    initOpenSubMenus() {
      this.menus.forEach((pitem) => {
        if (!this.hasOnlyOneChild(pitem)) {
          pitem.children.forEach((item) => {
            if (this.$route.fullPath == `${pitem.path}/${item.path}`) {
              this.$set(pitem, 'open', true);
            }
          });
        }
      });
    },

    //判断是否仅有一个可用菜单
    hasOnlyOneChild(menus) {
      return menus.children.filter((item) => !item.hidden).length == 1;
    },

    //获取第一个可用子路由
    getFirstChild(menus) {
      return menus.children.filter((item) => !item.hidden)[0];
    },

    //获取可能路由
    getAvalibleRouter(menus) {
      return menus.children.filter((item) => !item.hidden);
    },

    //获取菜单图标
    getIcon(menus) {
      return menus.meta.icon ? 'icon-' + menus.meta.icon : '';
    },

    //获取跳转路由
    getFullPath(parent, child) {
      return `${parent.path}/${child.path}`;
    },

    openSubMenu(menus) {
      this.$set(menus, 'open', !menus.open);
    },

    //子菜单是否存在高亮
    hasActiveSubmenu(menu) {
      return this.getAvalibleRouter(menu).filter((item) => this.activeIndex == item.path).length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.store-name {
  width: 100%;
  text-align: center;
  padding: 0 30px;
  box-sizing: border-box;
  height: 24px;
}

.aside {
  background: #001236;
  border-radius: 4px;
  overflow: hidden;
  color: #ffffff;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  width: 180px;
}

.store-info {
  padding: 40px 0;

  .logo-box {
    position: relative;
    margin-bottom: 18px;
    border-radius: 100%;
    overflow: hidden;

    &:after {
      opacity: 0;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      content: '修改LOGO';
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0, 18, 54, 0.8);
      cursor: pointer;
      transition: all 0.3s ease;
    }

    &:hover:after {
      opacity: 1;
    }
  }

  .logo {
    display: block;
    width: 70px;
    height: 70px;
    cursor: pointer;
  }
}

.menus-box {
  flex: 1;
  min-height: 0;
  width: 100%;
  overflow: hidden;
}

.menus {
  height: 100%;
  overflow-y: auto;
  padding-right: 20px;
  width: 100%;

  .menus-item {
    cursor: pointer;
    width: 180px;
  }

  .menus-item-icon {
    margin-right: 12px;
    width: 18px;
    font-size: 15px;
  }

  .menus-item-arrow {
    font-size: 12px;
    transition: transform 0.3s ease;

    &.active {
      transform: rotate(180deg);
    }
  }

  .menus-item-txt {
    flex: 1;
  }

  .menus-item-link,
  .menus-item-title {
    height: 60px;
    padding: 0 22px 0 26px;
    color: #fff;
    text-decoration: none;
    opacity: 0.9;

    &:hover,
    &.active {
      color: #4e81ff;
      opacity: 1;
    }
  }

  .level-1 .menus-item-link:hover,
  .level-1 .menus-item-link.active {
    background: #4e81ff;
    color: #fff;
  }

  .level-2 .menus-item-title:hover,
  .level-2 .menus-item-title.active {
    background: #4e81ff;
    color: #fff;
  }

  .level-2 .menus-item-link {
    background: #000205;
  }

  .menus-item-submenu {
    height: 0;
    overflow: hidden;
    transition: height 0.3s ease;
  }
}
</style>
